import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '../fragments/UserFragment'

export const UPDATE_USER = gql`
  mutation UpdateUser($data: UserInput!) {
    updateUser(data: $data) {
      ...User
    }
  }
  ${USER_FRAGMENT}
`
